import React from "react";

import { Box, TextField, Typography } from "@mui/material";

import CustomButton from "../../../helper-components/input/CustomButton";
import BackupCodesPanel from "../../auth/components/BackupCodesPanel";

import { regenerateBackupCodes } from "../../../helper-functions/api/authQueries";

export default function AccountMfa(props) {
    const [password, setPassword] = React.useState("");
    const [code, setCode] = React.useState("");
    const [codes, setCodes] = React.useState(null);
    const mfaEnabled = Boolean(props?.user?.me?.mfa_enabled);

    const submit = (event) => {
        event.preventDefault();
        regenerateBackupCodes(props, password, code, (nextCodes) => {
            setCodes(nextCodes);
            setPassword("");
            setCode("");
        });
    };

    if (codes) {
        return <BackupCodesPanel {...props} codes={codes} continueTitle="Done" onContinue={() => setCodes(null)} />;
    }

    return (
        <Box component="form" onSubmit={submit}>
            <Typography variant="body2" sx={{ mb: 1 }}>
                {mfaEnabled
                    ? "Authenticator sign-in is on. Generate a new set of backup codes if you have lost the previous ones. The old codes stop working."
                    : "The next sign-in will ask you to set up an authenticator app and will show backup codes once."}
            </Typography>
            {mfaEnabled && (
                <>
                    <TextField margin="normal" required fullWidth type="password" label="Password" value={password} onChange={(event) => setPassword(event.target.value)} />
                    <TextField margin="normal" required fullWidth label="Authenticator code" value={code} onChange={(event) => setCode(event.target.value)} inputProps={{ inputMode: "numeric" }} />
                    <CustomButton {...props} title="Create new backup codes" type="submit" />
                </>
            )}
        </Box>
    );
}
